import { render, staticRenderFns } from "./Duel_Feed.vue?vue&type=template&id=02706c17&"
import script from "./Duel_Feed.vue?vue&type=script&lang=js&"
export * from "./Duel_Feed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports